import { Component, OnDestroy } from "@angular/core";
import { DesignService } from "src/app/design/design.service";
import { singleSystem } from "../../system/system";
import { Design, DesignsEntity } from "src/app/design/design.model";
import { Subscription } from "rxjs";
import { MatSnackBar } from "@angular/material";
import { AuthService } from "src/app/auth.service";
import { ActivatedRoute } from "@angular/router";
import { SystemService } from "src/app/system/system.service";

@Component({
  selector: "app-copy-system",
  templateUrl: "./copy-system.component.html",
  styleUrls: ["./copy-system.component.css"],
})
export class CopySystemComponent implements OnDestroy {
  private subscription$ = new Subscription();
  showLoader: boolean = true;
  designs: DesignsEntity[];
  private newDesignId;
  private oldDesignId;


  searchDesign: string | number | any | null;

  constructor(
    private designService: DesignService,
    private systemService: SystemService,
    private snackBar: MatSnackBar,
    public auth: AuthService,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe((queryParams) => {
      if (queryParams?.id) {
        this.getCopyiedDesigns(queryParams.id);
        this.oldDesignId = queryParams.id;
      }
      if (queryParams?.newId) {
        this.newDesignId = queryParams.newId;
      }
    });
  }

  ngOnInit() {}

  /**
   * Get CopyDesigns List
   */
  getCopyiedDesigns(designId: any) {
    this.showLoader = true;
    this.subscription$.add(
      this.designService.getSystemByDesign(designId).subscribe(
        (result: Design) => {
          this.designs = result.system;
          this.showLoader = false;
          console.log(this.designs);
        },
        (error) => {
          this.showLoader = false;
          this.snackBar.open(`Error in Getting Copoed Designs  `, "", {
            duration: 2000,
          });
        }
      )
    );
  }

  createNewSystem(sys: singleSystem) {

    let newSys: singleSystem;
    newSys = sys;

    newSys.hvac_design_id = this.newDesignId;
    newSys.name = newSys.name + ' copy';

    this.systemService.newSystem(newSys).subscribe(
      (res) =>{
        console.log('system created')
      },err => {
        console.log('system not created.')
      }
    )

  }

  /**
   *
   */
  copySystems() : void {

    //create new systems records and attach them to the newly created design ID.
    console.log('copy systems');
    let newId = this.newDesignId;
    let sysServ = this.systemService;


    //get old systems
      this.designService.getSystemByDesign(this.oldDesignId).subscribe(
        (res) => {

          res.system.forEach(function(sys){

            //create new system
            console.log(sys);

            let newSys: singleSystem;
            newSys = sys;

            newSys.hvac_design_id = newId;
            newSys.name = newSys.name + ' copy';

            sysServ.newSystem(newSys).subscribe(
              (res) =>{
                console.log('system created')
              },err => {
                console.log('system not created.')
              }
            )


          })

        }, err => {
          console.log('error');
        }
        )



  }



  /**
   * unsubscribe the subscriptions
   */
  ngOnDestroy() {
    this.subscription$.unsubscribe();
  }
}
